import React, { ReactElement, useState } from "react";
import { Popup, List } from "semantic-ui-react";
import styles from "./Company.module.css";
import { Images } from "../../../constants";
import { COLOR_SCHEMES } from "../../../styles/colors/colors";

const { BLUE, PURPLE, PURPLE_SECONDARY } = COLOR_SCHEMES.PRIMARY_GRADIENT;
const GREYS = COLOR_SCHEMES.GREYS;
// Same brand gradient used by the section headers / gradient buttons.
const GRADIENT = `linear-gradient(45deg, ${BLUE}, ${PURPLE_SECONDARY}, ${PURPLE})`;

type IErrorProps = {
  errors: { [key: string]: string };
  // Optional: when provided, each error renders as a clickable highlighted box
  // and invokes this with (key, message) so the parent can navigate to the page.
  onErrorClick?: (key: string, message: string) => void;
};

export const ErrorPopupComponent: React.FC<IErrorProps> = ({
  errors,
  onErrorClick,
}): ReactElement => {
  const [hoveredKey, setHoveredKey] = useState<string | null>(null);

  return (
    <Popup
      content={
        onErrorClick ? (
          <div style={{ maxWidth: "320px" }}>
            {Object.entries(errors).map(([key, errorMessage]) => {
              const isHovered = hoveredKey === key;
              return (
                <div
                  key={key}
                  onClick={() => onErrorClick(key, errorMessage)}
                  onMouseEnter={() => setHoveredKey(key)}
                  onMouseLeave={() => setHoveredKey(null)}
                  style={{
                    position: "relative",
                    overflow: "hidden",
                    marginBottom: "10px",
                    padding: "10px 12px 10px 16px",
                    border: `1px solid ${PURPLE_SECONDARY}`,
                    borderRadius: "8px",
                    backgroundColor: isHovered ? "#faf2fc" : "#ffffff",
                    boxShadow: isHovered
                      ? "0 8px 20px rgba(161, 49, 199, 0.4)"
                      : "0 1px 3px rgba(0, 0, 0, 0.08)",
                    transform: isHovered ? "scale(1.03)" : "scale(1)",
                    cursor: "pointer",
                    transition:
                      "transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease",
                  }}
                >
                  {/* Brand-gradient accent strip */}
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: "4px",
                      background: GRADIENT,
                    }}
                  />
                  <div
                    style={{
                      fontWeight: 700,
                      color: GREYS["700"],
                      marginBottom: "2px",
                    }}
                  >
                    {key}
                  </div>
                  <div style={{ fontSize: "12px", color: GREYS["500"] }}>
                    {errorMessage}
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <List divided relaxed>
            {Object.entries(errors).map(([key, errorMessage]) => (
              <List.Item key={key}>
                <List.Content>
                  <List.Header>{key}</List.Header>
                  {errorMessage}
                </List.Content>
              </List.Item>
            ))}
          </List>
        )
      }
      trigger={
        <div className={styles.infoLogoContainer}>
          <div className={styles.styledInfoIcon}>
            <img src={Images.alertCircle} />
          </div>
        </div>
      }
      on="click"
      position="top center"
    />
  );
};

// export default ErrorPopupComponent;
